import { query } from "@/utils/api-utils";
import { request } from ".";

export const commentsApi = {
  getAll: (params: string) => request("/comments/me"+params),
}